import { NON_FSDS_DEFAULT_FAVICON_URL, NON_FSDS_DEFAULT_LOGO_URL } from '@/configs/non-fsds-config'

export interface BrandingIconSet {
  ico: string
  png16: string
  png32: string
  appleTouchIcon: string
  manifest: string
}

export interface BrandingMeta {
  siteName: string
  appTitle: string
  publisherName: string
  defaultDescription: string
  defaultKeywords: string
  twitterHandle: string
  themeColor: string
  locale: string
  language: string
  geoRegion: string
  geoPlacename: string
}

export interface DomainBrandingConfig {
  brandName: string
  brandHref: string
  logoUrl?: string
  meta: BrandingMeta
  icons: BrandingIconSet
}

export interface ResolvedDomainBrandingConfig extends DomainBrandingConfig {
  hostname: string
  isFsdsDomain: boolean
}

const DEFAULT_ICON_SET: BrandingIconSet = {
  ico: '/favicon.ico',
  png16: '/favicon/favicon-16x16.png',
  png32: '/favicon/favicon-32x32.png',
  appleTouchIcon: '/favicon/apple-touch-icon.png',
  manifest: '/favicon/site.webmanifest',
}

export const FSDS_DOMAIN_BRANDING: DomainBrandingConfig = {
  brandName: 'Full Stack Data Science',
  brandHref: '/',
  meta: {
    siteName: 'FSDS - Fullstack Data Science',
    appTitle: 'FSDS',
    publisherName: 'FSDS - Fullstack Data Science',
    defaultDescription:
      'Khám phá các khóa học toàn diện về Full Stack Data Science, bao gồm MLE, MLOps, CV Engineering và NLP Engineering.',
    defaultKeywords: 'data science, machine learning, fullstack, FSDS, AI, MLOps, CV Engineering, NLP Engineering',
    twitterHandle: '@FSDS_VN',
    themeColor: '#3b82f6',
    locale: 'vi_VN',
    language: 'Vietnamese',
    geoRegion: 'VN',
    geoPlacename: 'Vietnam',
  },
  icons: DEFAULT_ICON_SET,
}

const NON_FSDS_ICON_SET: BrandingIconSet = {
  ico: NON_FSDS_DEFAULT_FAVICON_URL,
  png16: NON_FSDS_DEFAULT_FAVICON_URL,
  png32: NON_FSDS_DEFAULT_FAVICON_URL,
  appleTouchIcon: NON_FSDS_DEFAULT_FAVICON_URL,
  manifest: '/favicon/site.webmanifest',
}

export const NON_FSDS_FALLBACK_BRANDING: DomainBrandingConfig = {
  brandName: 'Data Platform',
  brandHref: '/',
  logoUrl: NON_FSDS_DEFAULT_LOGO_URL,
  meta: {
    siteName: 'Data Platform',
    appTitle: 'Data Platform',
    publisherName: 'Data Platform',
    defaultDescription: 'Explore comprehensive courses and resources on our data platform.',
    defaultKeywords: 'data science, machine learning, AI, courses, learning platform',
    twitterHandle: '',
    themeColor: '#3b82f6',
    locale: 'vi_VN',
    language: 'Vietnamese',
    geoRegion: 'VN',
    geoPlacename: 'Vietnam',
  },
  icons: NON_FSDS_ICON_SET,
}

export const DOMAIN_BRANDING_OVERRIDES: Record<string, Partial<DomainBrandingConfig>> = {}
